import * as init from './initial-state'
import UUID from 'node-uuid'
import _ from 'lodash'

export default function search (state = init.initialState, action) {
  switch (action.type) {
    case 'RESET_JEWELRY_SEARCH':
      // reset everything other than:
      // 1). current jewelry ID on reset
      // 2). verticalShankThicknessOptions
      // 3). defaultShankWidthOptions
      // 4). defaultHaloWidthOptions
      return {
        ...init.initialState,
        isResetting: true,
        currentJewelryId: state.currentJewelryId,
        verticalShankThicknessOptions: state.verticalShankThicknessOptions,
        defaultShankWidthOptions: state.defaultShankWidthOptions,
        defaultHaloWidthOptions: state.defaultHaloWidthOptions
      }
    case 'SET_JEWELRY_SEARCH_FILTER_VALUE':
      return {
        ...state,
        currentJewelryPriceIsFresh: false,
        isResetting: false,
        filters: {
          ...state.filters,
          [action.key]: action.value
        }
      }
    case 'SET_JEWELRY_SEARCH_RESULT':
      return {
        ...state,
        result: action.value,
        currentJewelryPriceIsFresh: true,
        errorMsg: null
      }
    case 'SET_ERROR_MSG':
      return {
        ...state,
        errorMsg: action.value,
        result: {},
        currentJewelryPriceIsFresh: false
      }
    case 'SET_JEWELRY_MODAL_DATA':
      return {
        ...state,
        modalRow: Object.assign({}, {additionalNotes: action.value.additionalNotes}, action.value.data)
      }
    case 'OPEN_MODAL':
      return {
        ...state,
        modalOpen: action.value === 'jewelry'
      }
    case 'CLOSE_MODAL':
      return {
        ...state,
        modalOpen: false,
        modalRow: null
      }
    case 'ADD_JEWELRY_TO_CART':
      return {
        ...state,
        currentJewelryId: action.value.id
      }
    case 'REMOVE_JEWELRY_FROM_CART':
      if (state.currentJewelryId === parseInt(action.value)) {
        return {
          ...state,
          currentJewelryId: null
        }
      } else {
        return state
      }
    case 'CLEAR_CURRENT_JEWELRY':
      return {
        ...state,
        currentJewelryId: null,
        result: {}
      }
    case 'EDIT_JEWELRY':
      return {
        ...state,
        currentJewelryId: action.value.id,
        result: action.value.data,
        filters: action.value.filters
      }
    case 'SET_MULTI_STONE_SIZE_OPTIONS':
      return {
        ...state,
        filters: {
          ...state.filters,
          small_diamond_id: null
        },
        multiStoneSizeOption: action.value
      }
    case 'ADD_ADDITIONAL_DIAMOND':
      return {
        ...state,
        currentJewelryPriceIsFresh: false,
        filters: {
          ...state.filters,
          additional_diamonds: {
            ...state.filters.additional_diamonds,
            [UUID.v4()]: init.additionalDiamondsFilters
          }
        }
      }
    case 'REMOVE_ADDITIONAL_DIAMOND':
      return {
        ...state,
        currentJewelryPriceIsFresh: false,
        filters: {
          ...state.filters,
          additional_diamonds: {
            ..._.omit(state.filters.additional_diamonds, action.id)
          }
        }
      }
    case 'UPDATE_ADDITIONAL_DIAMOND':
      return {
        ...state,
        currentJewelryPriceIsFresh: false,
        filters: {
          ...state.filters,
          additional_diamonds: {
            ...state.filters.additional_diamonds,
            [action.id]: {
              ...state.filters.additional_diamonds[action.id],
              [action.field]: action.value
            }
          }
        }
      }
    case 'SET_ADDITIONAL_DIAMOND_SIZE_OPTIONS':
      return {
        ...state,
        filters: {
          ...state.filters,
          additional_diamonds: {
            ...state.filters.additional_diamonds,
            [action.id]: {
              ...state.filters.additional_diamonds[action.id],
              size_options: action.options,
              small_diamond_id: null
            }
          }
        }
      }
    case 'SET_VERTICAL_SHANK_THICKNESS':
      return {
        ...state,
        verticalShankThicknessOptions: action.options
      }
    case 'SET_DEFAULT_SHANK_WIDTH':
      return {
        ...state,
        defaultShankWidthOptions: action.options
      }
    case 'SET_DEFAULT_HALO_WIDTH':
      return {
        ...state,
        defaultHaloWidthOptions: action.options
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/jewelry-search/index.js